import { render, staticRenderFns } from "./programList.vue?vue&type=template&id=8ad50c56&scoped=true"
import script from "./programList.vue?vue&type=script&lang=js"
export * from "./programList.vue?vue&type=script&lang=js"
import style0 from "./programList.vue?vue&type=style&index=0&id=8ad50c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad50c56",
  null
  
)

export default component.exports